import {Injectable,OnDestroy} from '@angular/core';
import {Actions,createEffect,ofType} from '@ngrx/effects';
import {Observable,Subscription} from 'rxjs';
import {map} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {Action} from '@domain/action';
import {AppState} from '@domain/appstate';
import {FRAIS_CARTE_FROM_MENU,FraisCarteState} from "@reducers/frais-carte";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {CollabListComponent} from "../workflow/collab-list/collab-list.component";
import {UserDto} from "@domain/user/user-dto";
import {Router} from "@angular/router";
import {Session} from "@domain/security/session";
import {TypeProfil} from "@domain/user/user";

/**
 * Classe injectable pour la gestion via reducer d'un clic sur les cartes affaires dans le menu latéral
 */
@Injectable()
export class OpecarteEffects implements OnDestroy {
    /** Session en cours */
    session: Session;

    /** Souscription */
    souscription: Subscription;

    /**
     * Constructeur
     */
    constructor(private actions$: Actions,private store: Store<AppState>,private matDialog: MatDialog,private router: Router) {
        //Abonnement aux mises à jour de session
        this.souscription = this.store.select<Session>(s => s.session).subscribe(session => {
            //Mémorisation de la session
            this.session = session;
        });
    }

    /**
     * Abonnement aux évènements de clic sur le bouton des frais dans le menu
     */

    openCollabPopupForFraisCartes$: Observable<Action<FraisCarteState>> = createEffect(() => this.actions$.pipe(
        ofType(FRAIS_CARTE_FROM_MENU),
        map((action: Action<FraisCarteState>) => {
            //Si la payload est à true
            if (!!action.payload) {
                //Si l'utilisateur est connecté comme ASSISTANT
                if (this.session?.user?.fonction == TypeProfil.ASSISTANT) {
                    //Ouverture de la fenêtre de sélection du collaborateur
                    this.matDialog.open<CollabListComponent,any,UserDto>(CollabListComponent,{
                        data: {
                            purpose: CollabListComponent.Purpose.SEE_CARD_OPERATIONS_FOR_COLLAB
                        }
                    }).afterClosed().subscribe({
                        next: collab => {
                            //Si un collaborateur a été choisi
                            if (collab) {
                                //Navigation vers la page de liste des opérations cartes pour l'utilisateur concerné
                                this.router.navigate([`ListeOpeCarte/${collab.idUser}`]);
                            }

                            //Réinitialisation du store de frais cartes
                            this.store.dispatch({
                                type: FRAIS_CARTE_FROM_MENU,
                                payload: false
                            });
                        }
                    });
                } else {
                    //Sinon, navigation vers la page de liste des opérations cartes pour l'utilisateur connecté
                    this.router.navigate(['ListeOpeCarte']);

                    //Réinitialisation du store de frais cartes
                    this.store.dispatch({
                        type: FRAIS_CARTE_FROM_MENU,
                        payload: false
                    });
                }
            }

            //Retour de l'action
            return action;
        })
    ),{dispatch: false});

    /**
     * Destruction du composant
     */
    ngOnDestroy() {
        //Résiliation
        this.souscription.unsubscribe();
    }
}
